export default [{
  name: '个人中心',
  desc: '个人中心',
  path: '/center',
}, {
  name: '授权说明',
  desc: '授权说明',
  path: '/intro'
}, {
  name: '答疑说明',
  desc: '答疑说明',
  path: '/qa'
}, {
  name: '联系我们',
  desc: '联系我们',
  path: '/contact'
}]

